import { Injectable } from "@angular/core";
import { AppError, AppErrorType, CoreHttpClient } from "@obg/ngx.core";
import { StatusCodes } from "@obg/ngx.global";
import { Observable, throwError } from "rxjs";

import { OmsConfigService } from "./oms.config";
import {
	NotificationsInfo,
	NotificationsInfoRequest,
	OmsMessage,
	OmsMessageStatus,
	OmsService,
	OmsUserSettings,
	UpdateMessage,
} from "./oms.model";

/**
 * @deprecated - [fabric-deprecated]
 */
@Injectable()
export class CoreOmsService implements OmsService {
	constructor(
		private config: OmsConfigService,
		private httpClient: CoreHttpClient
	) {}

	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.retrieve(AccountAppValue.GetNotificationsByStatus) instead
	 */
	getNotificationsByStatus(state: OmsMessageStatus): Observable<OmsMessage[]> {
		const url =
			state === OmsMessageStatus.Active
				? this.config.getEndpointNotificationsActive()
				: this.config.getEndpointNotificationsExpired();

		return this.httpClient.get<OmsMessage[]>({ url });
	}

	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.UpdateMessage) instead
	 */
	updateMessage(updateMessage: UpdateMessage): Observable<unknown> {
		return this.httpClient.patch({
			url: this.config.getEndpointUpdateMessage(),
			data: updateMessage,
			searchParams: { messageId: updateMessage.messageId },
		});
	}

	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.UpdateMessages) instead
	 */
	updateMessages(updateMessages: UpdateMessage[]): Observable<unknown> {
		return this.httpClient.patch({
			url: this.config.getEndpointUpdateMessages(),
			data: updateMessages,
		});
	}

	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.retrieve(AccountAppValue.GetAlerts)
	 * OR
	 * document.obgEventBus.retrieve(AccountAppValue.PollAlerts) instead
	 */
	getAlerts(context: string): Observable<OmsMessage[]> {
		if (context) {
			return this.httpClient.get<OmsMessage[]>({
				url: this.config.getEndpointAlerts(),
				searchParams: { context },
			});
		}
		return throwError(
			() =>
				({
					type: AppErrorType.BadRequest,
					code: "invalid-alerts-context",
				}) as AppError
		);
	}

	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.retrieve(AccountAppValue.PollNotificationsInfo)
	 * OR
	 * document.obgEventBus.retrieve(AccountAppValue.GetNotificationsInfo) instead
	 */
	getNotificationsInfo(notificationInfoParams: NotificationsInfoRequest): Observable<NotificationsInfo> {
		return this.httpClient.get<NotificationsInfo>({
			url: this.config.getEndpointNotificationsInfo(),
			searchParams: notificationInfoParams,
			suppressErrorLogging: [StatusCodes.Unauthorized],
		});
	}

	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.retrieve(AccountAppValue.GetOmsUserSettings) instead
	 */
	getUserSettings(): Observable<OmsUserSettings> {
		return this.httpClient.get<OmsUserSettings>({
			url: this.config.getEndpointUserSettings(),
		});
	}

	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.UpdateOmsUserSettings) instead
	 */
	updateUserSettings(userSettings: OmsUserSettings): Observable<OmsUserSettings> {
		return this.httpClient.patch<OmsUserSettings>({
			url: this.config.getEndpointUserSettings(),
			data: userSettings,
		});
	}
}
